import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { SessionManagerSiteConfig } from '../types'
import type { DynamicSessionModel } from '@wix/thunderbolt-symbols'
import { AUTHORIZATION_CODE_QUERY_PARAM } from '@wix/thunderbolt-symbols'
import type { TPAPublicClientSpecEntry } from '@wix/thunderbolt-ssr-api'

const sessionManagerSiteConfig: SiteConfigFn<SessionManagerSiteConfig> = ({ api, funcLib }) => {
	const url = api.originalRequest.getUrl()
	const expiryTimeoutOverride = parseInt(funcLib.getQueryParamValue(url, 'expiryTimeoutOverride') || '0', 10)

	// Find sitemembers app
	const clientSpecMap = api.rendererModel.getClientSpecMap() || {}
	let smToken: string | undefined
	for (const app of Object.values(clientSpecMap)) {
		if (app.type === 'sitemembers') {
			smToken = (app as any).smtoken
			break
		}
	}

	// Check if running in different site context
	const authCodeParam = funcLib.getQueryParamValue(url, AUTHORIZATION_CODE_QUERY_PARAM)
	const isRunningInDifferentSiteContext = !!authCodeParam

	// Build appsInstances
	const appsInstances: { [appDefId: string]: { instance: string } } = {}
	for (const app of Object.values(clientSpecMap)) {
		const appEntry = app as TPAPublicClientSpecEntry
		if (appEntry.appDefinitionId) {
			appsInstances[appEntry.appDefinitionId] = { instance: appEntry.instance as string }
		}
	}

	// Build sessionModel (only when running in different site context)
	let sessionModel: Partial<DynamicSessionModel> = {}
	if (isRunningInDifferentSiteContext) {
		const sessionInfo = api.publicModel.getSessionInfo()
		const mediaAuthToken = api.rendererModel.getMediaAuthToken()

		sessionModel = {
			apps: appsInstances,
			smToken,
			svSession: sessionInfo?.svSession,
			ctToken: sessionInfo?.ctToken,
			hs: sessionInfo?.hs,
			mediaAuthToken,
			visitorId: sessionInfo?.visitorId,
			siteMemberId: sessionInfo?.siteMemberId,
			contactId: sessionInfo?.contactId,
			metaSiteId: api.rendererModel.getMetaSiteId(),
		}
	}

	// Check experiment for dynamicModelApiUrl
	const runningExperiments = api.rendererModel.getRunningExperiments() || {}
	const shouldRemoveDynamicModel =
		runningExperiments['specs.thunderbolt.removeDynamicModelTopologyFromSiteAssets'] === 'true'
	const dynamicModelApiUrl = shouldRemoveDynamicModel ? '' : api.publicModel.getDynamicModelUrl()

	const sessionInfo = api.publicModel.getSessionInfo()
	const svSession = sessionInfo?.svSession as string
	const accessTokensApiUrl = api.publicModel.getAccessTokensUrl()

	const siteConfig: SessionManagerSiteConfig = {
		sessionModel,
		appsInstances,
		dynamicModelApiUrl,
		accessTokensApiUrl,
		expiryTimeoutOverride,
		svSession,
		smToken,
		isRunningInDifferentSiteContext,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'sessionManager'

export const config = { site: sessionManagerSiteConfig, name }
